import { createContext, useContext } from 'react';
import type { ZoomContextType } from './ZoomContext.types';

const ZoomContext = createContext<ZoomContextType | undefined>(undefined);

export const useZoom = (): ZoomContextType => {
  const context = useContext(ZoomContext);
  if (!context) {
    throw new Error('useZoom must be used within a ZoomProvider');
  }
  return context;
};

export { DEFAULT_ZOOM_LEVEL, ZOOM_CONFIG } from './ZoomContext.constants';
export type { ZoomContextType } from './ZoomContext.types';
export {
  clampZoom,
  getNextZoomLevel,
  loadZoomFromStorage,
  roundZoomLevel,
  saveZoomToStorage,
} from './ZoomContext.utilities';
export { ZoomContext };
